export default __webpack_public_path__ + "static/media/instagram.e1d961a1.svg";